<style lang="less" scoped>
  .number {
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #fff800;
  }
</style>

<template lang="pug">
  .number-row
    span.number(v-for='number in data') {{number}}
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/number_display.vue